import { useEffect, useState } from 'react'
import { api, type AccountSummary } from '../lib/api.ts'
import { Button } from '../components/Button.tsx'
import { DataTable, type Column } from '../components/DataTable.tsx'
import { icons } from '../components/icons.ts'

/** Every customer. Opening one is where its rules are configured. */
export function Accounts({ onBack, onOpen }: { onBack: () => void; onOpen: (id: string) => void }) {
  const [accounts, setAccounts] = useState<AccountSummary[]>([])
  const [error, setError] = useState<string | undefined>()
  const [loading, setLoading] = useState(true)

  function load() {
    setLoading(true)
    setError(undefined)
    void api
      .accounts()
      .then((r) => setAccounts(r.accounts))
      .catch((cause: unknown) =>
        setError(cause instanceof Error ? cause.message : 'falha ao carregar'),
      )
      .finally(() => setLoading(false))
  }

  useEffect(load, [])

  return (
    <div className="flex flex-col gap-5 p-5 pt-0">
      <div className="flex flex-wrap items-center gap-3">
        <Button
          variant="tertiary"
          tone="neutral"
          size="small"
          leadingIcon={icons.back}
          onClick={onBack}
        >
          Fila
        </Button>
        <h1 className="text-tH4 text-text-strong">Contas</h1>
      </div>

      <DataTable
        columns={COLUMNS}
        rows={accounts}
        rowKey={(a) => a.id}
        loading={loading}
        error={error}
        onRetry={load}
        onRowClick={(a) => onOpen(a.id)}
        pageSize={4}
        empty="Nenhuma conta."
      />
    </div>
  )
}

const COLUMNS: ReadonlyArray<Column<AccountSummary>> = [
  { key: 'name', header: 'Nome', render: (a) => a.name },
  {
    key: 'slug',
    header: 'Identificador',
    className: 'font-mono text-text-weak',
    render: (a) => a.slug,
  },
  {
    key: 'kind',
    header: 'Tipo',
    className: 'text-text-weak',
    render: (a) => (a.internal ? 'Interna' : 'Cliente'),
  },
  {
    key: 'branches',
    header: 'Filiais',
    className: 'tabular-nums text-text-weak',
    render: (a) => a.branches,
  },
  {
    key: 'people',
    header: 'Usuários',
    className: 'tabular-nums text-text-weak',
    render: (a) => a.people,
  },
  {
    key: 'catalog',
    header: 'Catálogo',
    className: 'text-tSmall text-text-weak',
    render: (a) =>
      a.catalogSyncedAt === undefined
        ? 'nunca sincronizado'
        : new Date(a.catalogSyncedAt).toLocaleString('pt-BR', {
            dateStyle: 'short',
            timeStyle: 'short',
          }),
  },
]
